import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseUrlDashboard = `${environment.baseUrl}/dashboard`;
  baseUrlPathway = `${environment.baseUrl}/pathway`;
  baseUrlForum = `${environment.baseUrl}/forum`;
  baseUrlPhase1 = `${environment.baseUrl}/phase1`;
  constructor(private http: HttpClient) { }

  /**
   * Get overview detail
   */
  getOverviewDetail() {
    return this.http.get(`${this.baseUrlDashboard}/overview/details`);
  }

  /**
   * Get pathway details by Id
   */
  getPathwayDetail(pathwayId: any) {
    return this.http.get(`${this.baseUrlDashboard}/pathway/details/${pathwayId}`);
  }

  /**
   * Get pathway details by Id
   */
  updateTangramDetails(data: any) {
    return this.http.post(`${this.baseUrlPathway}/update`, data);
  }

  /**
   * Get video detail 
   */
  getVideoDetail(videoId) {
    return this.http.get(`${this.baseUrlDashboard}/video/details/${videoId}`);
  }

  /**
   * Get video detail for public page
   */
   getVideoDetailPublic(videoId) {
    return this.http.get(`${this.baseUrlDashboard}/public/video/details/${videoId}`);
  }

  /**
   * Get video comments list
   * @param videoId videoId for which video comments
   */
  getVideoCommentsList(videoData: any, type: any, visibility: any) {
    let params = type == 'all' ? new HttpParams().set("videoId", videoData.videoId) : new HttpParams().set("videoId", videoData.videoId).set("type", videoData.type);
    params = params.set("page", videoData.page).set("limit", videoData.limit)
    params = params.set("isFlagged", videoData.isFlagged).set("pathwayId", videoData.pathwayId);
    params = params.set("timeSlot", videoData.timeSlot);
    if (visibility == 'public') {
      return this.http.get(`${this.baseUrlDashboard}/public/video/comment`, { params });
    }
    return this.http.get(`${this.baseUrlDashboard}/video/comment`, { params });
  }

  /**
   * add comment with type
   * @param data 
   */
  addUserComment(data: any) {
    return this.http.post(`${this.baseUrlDashboard}/video/comment`, data);
  }

  /**
   * Reply chat comment
   * @param data data to be replied
   */
  replyChatComment(data: any) {
    return this.http.post(`${this.baseUrlDashboard}/comment/reply`, data);
  }

  /**
   * like dislike comment
   * @param data comment liked or disliked
   */
  likeDisLikeComment(data: any) {
    return this.http.post(`${this.baseUrlDashboard}/comment/likeDislike`, data);
  }

  /**
   * Like dislike video
   * @param data data to be liked or disliked
   */
  likeDislikeVideo(data: any) {
    return this.http.post(`${this.baseUrlDashboard}/video/likeDislike`, data);
  }

  /**
   * Bookmarks tangram
   * @param data videos to be bookmarked
   */
  bookmarkPathway(data: any) {
    return this.http.post(`${environment.baseUrl}/pathway/bookmarkPathway`, data);
  }

  /**
   * Checks if the current tangram is bookmarked or not
   * @param data user id and pathway id
   */
  isPathwayBookmarked(data: any) {
    return this.http.get(`${environment.baseUrl}/pathway/isBookmarked/${data.userId}/${data.pathwayId}`);
  }

  /**
   * Track video watch
   * @param data data to be tracked
   */
  trackVideoWatch(data) {
    return this.http.post(`${environment.baseUrl}/dashboard/video/watch`, data);
  }

  /**
   * Get tracked video watch
   * @param videoId videoId for which video percentage
   */
  getTrackedVideoWatch(videoId) {
    return this.http.get(`${environment.baseUrl}/dashboard/video/watch/${videoId}`);
  }

  /**
   * Flag comment
   * @param comment comment to be flagged
   */
  flagComment(comment) {
    return this.http.put(`${environment.baseUrl}/dashboard/video/comment`, comment);
  }

  /**
   * Get User Detail 
   * @param userId to retrive user detail
   */
  getUserDetail(userId: any) {
    return this.http.get(`${environment.baseUrl}/users/?_id=${userId}`);
  }

  /** FORUM API */
  getForumQuestions(params: any, type) {
    let forumParams = type == 'all' ? new HttpParams().set("type", params.type).set("page", params.page).set("limit", params.limit).set("isFlagged", params.isFlagged) : new HttpParams().set("_id", params._id);
    if (params.search) {
      forumParams = forumParams.set("search", params.search);
    }
    forumParams = forumParams.set("pathwayId", params.pathwayId);
    return this.http.get(`${this.baseUrlForum}/questions`, { params: forumParams });
  }

  /**
   * Add forum question
   * @param data data
   * @param pathwayId
   */
  addForumQuestion(data, pathwayId: string) {
    data["pathwayId"] = pathwayId;
    return this.http.post(`${environment.baseUrl}/forum/questions/add`, data);
  }

  /** Get all anwers of particular question */
  getAllAnswersOfQuestion(questionId, isFlagged) {
    const answerParams = new HttpParams().set("questionId", questionId).set("isFlagged", isFlagged);
    return this.http.get(`${this.baseUrlForum}/answers`, { params: answerParams });
  }


  /** Get all anwers of particular question */
  addAnswersOfQuestion(answerDetail: any, pathwayId: string) {
    answerDetail["pathwayId"] = pathwayId;
    return this.http.post(`${this.baseUrlForum}/answers/add`, answerDetail);
  }

  /** upvote downvote and like api to update votes */
  updateUpDownLikeVoteAnswer(votes: any) {
    return this.http.post(`${this.baseUrlForum}/answers/upvotesDownvotes`, votes);
  }

  /**  forum answers flag set in question */
  flagForumAnswer(flagDetail: any) {
    return this.http.put(`${this.baseUrlForum}/answers`, flagDetail);
  }

  /**  forum question flag set in question */
  flagForumQuestion(flagDetail: any) {
    return this.http.post(`${this.baseUrlDashboard}/updateForumQuestions`, flagDetail);
  }
  /**
   * get top voices to display on leaderboard
   * @param paginationDetail get data pagianted
   */
  getTopVoices(paginationDetail) {
    const topVoiceParams = new HttpParams().set("page", paginationDetail.page).set("limit", paginationDetail.limit).set("pathwayId", paginationDetail.pathwayId);
    return this.http.get(`${environment.baseUrl}/topvoice/getTopVoice`, { params: topVoiceParams });
  }

  /**
   * Get most active members
   * @param pathwayId pathwayId for which pathway
   */
  getMostActiveMembers(pathwayId: string) {
    return this.http.get(`${environment.baseUrl}/users/getActiveMember/${pathwayId}`);
  }

  /**
   * submit feedback data
   * @param feedbackData feedback to be stored
   */
  submitUserFeedback(feedbackData: any) {
    return this.http.post(`${this.baseUrlDashboard}/postfeedback`, feedbackData);
  }


  /**
   * submit contact us data
   * @param contactUsData contact to be stored
   */
  submitContactUsForm(contactUsData: any) {
    return this.http.post(`${environment.baseUrl}/users/contactUs`, contactUsData);
  }

  /**
   * follow unfollow user from chatstream and forum
   * @param data follow/unfollow user
   */
  followUnfollowUser(data) {
    return this.http.post(`${environment.baseUrl}/users/followUnfollow`, data);
  }

  /**
   * Send email to download app
   * @param data data
   */
  sendEmailToDownloadApp(data: any) {
    return this.http.post(`${environment.baseUrl}/users/downloadAppEmail`, data);
  }

  /**
   * Store email in admin panel while download app
   * @param data data
   */
  storeEmailForDownloadApp(data: any) {
    return this.http.post(`${this.baseUrlDashboard}/postDownloadEmail`, data);
  }


  /**
   * Get video hot spot
   * @param videoId videoId
   */
  getVideoHotSpots(videoId: string, visibility: string) {
    if (visibility == 'public') {
      return this.http.get(`${environment.baseUrl}/dashboard/public/video/getVideoTimeSlotComment/${videoId}`);
    }
    return this.http.get(`${environment.baseUrl}/dashboard/video/getVideoTimeSlotComment/${videoId}`);
  }

  /**
   * Get my tangram list
   */
  getMyTangramList() {
    return this.http.get(`${environment.baseUrl}/pathway/getMyTangram`);
  }

  /**
   * Get my draft tangrams (isDraft: true, owned by current user).
   */
  getMyDraftsList() {
    return this.http.get(`${environment.baseUrl}/pathway/getMyDrafts`);
  }

  /**
   * Publish a draft tangram — flips isDraft from true to false.
   */
  publishDraft(pathwayId: string) {
    return this.http.patch(`${environment.baseUrl}/pathway/publishDraft/${pathwayId}`, {});
  }

  /**
   * Get my tangram list
   */
  getMyBookmarksList(data: any) {
    return this.http.get(`${environment.baseUrl}/pathway/getMyBookmarks/${data.userId}`);
  }

  /**
   * Update orders of the videos (rearrange order)
   */
  updateVideosOrder(data: any) {
    return this.http.put(`${this.baseUrlDashboard}/video/orderUpdate`, data);
  }

  deleteTangram(data : Record<string, any>){
    return this.http.post(`${environment.baseUrl}/pathway/deleteTangram`, data);
  }

  deleteMedia(data : Record<string, any>){
    return this.http.post(`${environment.baseUrl}/pathway/deleteMedia`, data);
  }

  deleteComment(data : Record<string, any>){
    return this.http.post(`${this.baseUrlDashboard}/video/deleteComment`, data);
  }
  
  disableCommenting(data : Record<string, any>) {
    return this.http.post(`${environment.baseUrl}/dashboard/disableComment`, data);
  }
  getMyFollowingUsers() {
    return this.http.get<any>(`${environment.baseUrl}/users/getFollowUser`);
  }

  /**
   * Validate pathway password
   */
  validatePathwayPassword(pathwayId: string, password: string) {
    return this.http.post(`${this.baseUrlPathway}/validate-password`, {
      pathwayId: pathwayId,
      password: password
    });
  }

  /**
   * Update Tangram password
   */
  updateTangramPassword(pathwayId: string, password: string) {
    return this.http.post(`${this.baseUrlPathway}/update-password`, {
      pathwayId: pathwayId,
      password: password
    });
  }

  /**
   * Remove Tangram password
   */
  removeTangramPassword(pathwayId: string) {
    return this.http.post(`${this.baseUrlPathway}/remove-password`, {
      pathwayId: pathwayId
    });
  }

  /**
   * Check invite access for a pathway
   */
  checkInviteAccess(pathwayId: string) {
    return this.http.get(`${this.baseUrlPathway}/check-invite-access/${pathwayId}`);
  }
  /**
   * Send invite-only invitations
   */
  sendInviteOnlyInvitations(pathwayId: string, emails: string[], message: string) {
    return this.http.post(`${this.baseUrlPathway}/send-invitations`, {
      pathwayId: pathwayId,
      emails: emails,
      message: message
    });
  }

  /**
   * Get invited emails for a pathway
   */
  getInvitedEmails(pathwayId: string) {
    return this.http.get(`${this.baseUrlPathway}/invited-emails/${pathwayId}`);
  }

  /**
   * Remove invited email from a pathway
   */
  removeInvitedEmail(pathwayId: string, email: string) {
    return this.http.post(`${this.baseUrlPathway}/remove-invited-email`, {
      pathwayId: pathwayId,
      email: email
    });
  }

  /**
   * Update access types for invited emails
   */
  updateInvitedAccess(pathwayId: string, emailUpdates: any[]) {
    return this.http.post(`${this.baseUrlPathway}/update-invited-access`, {
      pathwayId: pathwayId,
      emailUpdates: emailUpdates
    });
  }

  // ==================== Phase 1 - Star Rating ====================

  /**
   * Submit or update star rating for a pathway
   */
  upsertStarRating(pathwayId: string, rating: number) {
    return this.http.post(`${this.baseUrlPhase1}/star-rating`, { pathwayId, rating });
  }

  /**
   * Get star rating for a pathway (user's rating + average)
   */
  getStarRating(pathwayId: string) {
    return this.http.get(`${this.baseUrlPhase1}/star-rating/${pathwayId}`);
  }

  getBatchStarRatings(pathwayIds: string[]) {
    return this.http.post(`${this.baseUrlPhase1}/star-rating/batch`, { pathwayIds });
  }

  // ==================== Phase 1 - Media Star Rating ====================

  upsertMediaStarRating(videoId: string, pathwayId: string, rating: number) {
    return this.http.post(`${this.baseUrlPhase1}/media-star-rating`, { videoId, pathwayId, rating });
  }

  getMediaStarRating(videoId: string) {
    return this.http.get(`${this.baseUrlPhase1}/media-star-rating/${videoId}`);
  }

  getPathwayAverageMediaStarRating(pathwayId: string) {
    return this.http.get(`${this.baseUrlPhase1}/media-star-rating/pathway/${pathwayId}`);
  }

  // ==================== Phase 1 - Pathway Completion ====================

  /**
   * Toggle pathway completion status
   */
  togglePathwayCompletion(pathwayId: string, isCompleted: boolean) {
    return this.http.post(`${this.baseUrlPhase1}/pathway-completion`, { pathwayId, isCompleted });
  }

  /**
   * Get pathway completion status and percentage
   */
  getPathwayCompletion(pathwayId: string) {
    return this.http.get(`${this.baseUrlPhase1}/pathway-completion/${pathwayId}`);
  }

  // ==================== Phase 1 - Media Completion ====================

  toggleMediaCompletion(videoId: string, pathwayId: string, isCompleted: boolean) {
    return this.http.post(`${this.baseUrlPhase1}/media-completion`, { videoId, pathwayId, isCompleted });
  }

  getMediaCompletions(pathwayId: string) {
    return this.http.get(`${this.baseUrlPhase1}/media-completion/${pathwayId}`);
  }

  getBatchMediaCompletions(pathwayIds: string[]) {
    return this.http.post(`${this.baseUrlPhase1}/media-completion/batch`, { pathwayIds });
  }

  // ==================== Phase 1 - Personal Notes ====================

  /**
   * Create a personal note for a pathway (optionally scoped to a specific media)
   */
  createNote(pathwayId: string, text: string, isPrivate: boolean, videoId?: string, isMarkdown: boolean = false) {
    const body: any = { pathwayId, text, isPrivate };
    if (videoId) body.videoId = videoId;
    if (isMarkdown) body.isMarkdown = true;
    return this.http.post(`${this.baseUrlPhase1}/notes`, body);
  }

  /**
   * Get notes for a pathway (optionally filtered by videoId)
   */
  getNotes(pathwayId: string, videoId?: string) {
    let url = `${this.baseUrlPhase1}/notes/${pathwayId}`;
    if (videoId) url += `?videoId=${videoId}`;
    return this.http.get(url);
  }

  /**
   * Delete a note
   */
  deleteNoteApi(noteId: string) {
    return this.http.delete(`${this.baseUrlPhase1}/notes/${noteId}`);
  }

  // ==================== Phase 1 - Engagement Questions ====================

  /**
   * Create an engagement question
   */
  createEngagementQuestion(pathwayId: string, text: string, type: string, videoId?: string, options?: string[]) {
    const body: any = { pathwayId, text, type };
    if (videoId) body.videoId = videoId;
    if (options && options.length > 0) body.options = options;
    return this.http.post(`${this.baseUrlPhase1}/engagement/questions`, body);
  }

  /**
   * Smart question workflow ingest:
   * - queues / batches flagged learner questions
   * - attempts TA routing
   * - backend should fall back to professor when no TA is assigned
   */
  routeQuestionWorkflow(payload: {
    pathwayId: string;
    videoId?: string;
    text: string;
    source: 'chat-flag' | 'chat-question' | 'forum';
    preferredAssigneeRole?: 'TA' | 'PROFESSOR';
    fallbackAssigneeRole?: 'PROFESSOR';
    metadata?: any;
  }) {
    return this.http.post(`${this.baseUrlPhase1}/engagement/question-workflow/route`, payload);
  }

  /**
   * Optional workflow batching endpoint for digesting unresolved questions.
   */
  batchQuestionWorkflow(payload: { pathwayId: string; questionIds: string[]; trigger: 'threshold' | 'manual' | 'schedule' }) {
    return this.http.post(`${this.baseUrlPhase1}/engagement/question-workflow/batch`, payload);
  }

  /**
   * Get engagement questions for a pathway (optionally filtered by videoId)
   */
  getEngagementQuestions(pathwayId: string, videoId?: string) {
    let url = `${this.baseUrlPhase1}/engagement/questions/${pathwayId}`;
    if (videoId) url += `?videoId=${videoId}`;
    return this.http.get(url);
  }

  /**
   * Submit an answer to an engagement question
   */
  submitEngagementAnswer(questionId: string, text: string) {
    return this.http.post(`${this.baseUrlPhase1}/engagement/questions/${questionId}/answer`, { text });
  }

  /**
   * Delete an engagement question
   */
  deleteEngagementQuestion(questionId: string) {
    return this.http.delete(`${this.baseUrlPhase1}/engagement/questions/${questionId}`);
  }

  /**
   * Update an engagement question (text / type / options).
   */
  updateEngagementQuestion(questionId: string, text: string, type: string, options?: string[]) {
    const body: any = { text, type };
    if (options && options.length > 0) body.options = options;
    return this.http.put(`${this.baseUrlPhase1}/engagement/questions/${questionId}`, body);
  }

  reorderQuestions(orderedIds: string[]) {
    return this.http.put(`${this.baseUrlPhase1}/engagement/questions/reorder`, { orderedIds });
  }

  // ==================== Phase 1 - Polls ====================

  /**
   * Create a poll
   */
  createPollApi(pathwayId: string, question: string, options: string[], allowMultiple: boolean, videoId?: string) {
    const body: any = { pathwayId, question, options, allowMultiple };
    if (videoId) body.videoId = videoId;
    return this.http.post(`${this.baseUrlPhase1}/engagement/polls`, body);
  }

  /**
   * Get polls for a pathway (optionally filtered by videoId)
   */
  getPolls(pathwayId: string, videoId?: string) {
    let url = `${this.baseUrlPhase1}/engagement/polls/${pathwayId}`;
    if (videoId) url += `?videoId=${videoId}`;
    return this.http.get(url);
  }

  /**
   * Submit a vote on a poll
   */
  submitPollVote(pollId: string, selectedOptions: number[]) {
    return this.http.post(`${this.baseUrlPhase1}/engagement/polls/${pollId}/vote`, { selectedOptions });
  }

  deletePoll(pollId: string) {
    return this.http.delete(`${this.baseUrlPhase1}/engagement/polls/${pollId}`);
  }

  /**
   * Update a poll (question / options / allowMultiple). Editing resets votes.
   */
  updatePollApi(pollId: string, question: string, options: string[], allowMultiple: boolean) {
    return this.http.put(`${this.baseUrlPhase1}/engagement/polls/${pollId}`, { question, options, allowMultiple });
  }

  reorderPolls(orderedIds: string[]) {
    return this.http.put(`${this.baseUrlPhase1}/engagement/polls/reorder`, { orderedIds });
  }

}
